export default "__VITE_PUBLIC_ASSET__d5095b01__"